import React from "react";

const SummaryPanel = ({ summary, L }) => (
  <div className="hc-summary">
    <div className="hc-summary__item">
      <div className="hc-summary__value">{summary.total}</div>
      <div className="hc-summary__label">{L.totalIndicators}</div>
    </div>
    <div className="hc-summary__item">
      <div className="hc-summary__value hc-text-good">{summary.good}</div>
      <div className="hc-summary__label">{L.done}</div>
    </div>
    <div className="hc-summary__item">
      <div className="hc-summary__value hc-text-bad">{summary.bad}</div>
      <div className="hc-summary__label">
        {L.notDone}
        {summary.no_data > 0 && (
          <span className="hc-summary__nodata">
            {" "}
            · {L.noDataCount}: {summary.no_data}
          </span>
        )}
      </div>
    </div>
    <div className="hc-summary__item">
      <div className="hc-summary__value">{summary.completion_pct}%</div>
      <div className="hc-summary__label">{L.completion}</div>
    </div>
  </div>
);

export default SummaryPanel;
